export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgUm9sZSA9IHsKICBpZDogbnVtYmVyCiAgdXNlcl9yb2xlOiAnU3VwZXIgQWRtaW4nIHwgJ0FnZW5jeSBBZG1pbicgfCAnVXNlcicKfQo="